import { useState } from 'react';

const SmileCompareSlider = ({ beforeSrc, afterSrc, maxHeightClassName = 'max-h-[55vh]' }) => {
    const [sliderValue, setSliderValue] = useState(50);

    return (
        <div className="flex flex-col gap-3">
            <div className="relative w-fit max-w-full mx-auto rounded-xl overflow-hidden">
                <img
                    src={afterSrc}
                    alt="After"
                    className={`block w-auto max-w-full h-auto ${maxHeightClassName}`}
                />
                <div
                    className="absolute inset-0 overflow-hidden"
                    style={{ clipPath: `inset(0px ${100 - sliderValue}% 0px 0px)` }}
                >
                    <img src={beforeSrc} alt="Before" className="block w-full h-full" />
                </div>
                <div
                    className="absolute top-0 bottom-0 w-1 bg-white shadow-lg pointer-events-none"
                    style={{ left: `${sliderValue}%` }}
                />
            </div>
            <div>
                <input
                    type="range"
                    min="0"
                    max="100"
                    value={sliderValue}
                    onChange={(e) => setSliderValue(e.target.value)}
                    aria-label="Compare before and after"
                    className="w-full h-1 bg-[#E8E6E3] rounded-lg appearance-none cursor-pointer slider mb-2"
                    style={{
                        background: `linear-gradient(to right, rgb(45, 45, 45) 0%, rgb(45, 45, 45) ${sliderValue}%, rgb(232, 230, 227) ${sliderValue}%, rgb(232, 230, 227) 100%)`,
                    }}
                />
                <div className="flex items-center justify-between">
                    <span className="font-dashboard text-[10px] text-[#6B6B6B] uppercase tracking-[0.5px]">Before</span>
                    <span className="font-dashboard text-[10px] text-[#6B6B6B] uppercase tracking-[0.5px]">After</span>
                </div>
            </div>
        </div>
    );
};

export default SmileCompareSlider;
